/* eslint-disable no-use-before-define */
import React, { ReactNode, useState } from 'react';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Close } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import Search from '@jda/lui-common-icon-library/ui/Search';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      backgroundColor: theme.palette.info.main,
      margin: theme.spacing(0.5, 0.25),
      color: '#fff'
    },
    chipClose: {
      backgroundColor: theme.palette.info.main,
      color: '#fff',
      '&:hover, &:focus': {
        color: '#fff'
      }
    }
  })
);
type AutoCompleteData = {
  values: any;
  placeholder: string;
  onChange: any;
  value: any;
  name?: any;
};
export const AutoCompleteComponent = (props: AutoCompleteData) => {
  const [val, setVal] = useState(props.value || []);

  React.useEffect(() => {
    setVal(props.value);
  }, [props.value]);

  const classes = useStyles();
  const valHtml = val.map((option: any, index: any) => {
    const label = option.title || option;
    return (
      <Chip
        data-id="autocomplete-chip"
        className={classes.chip}
        key={label}
        label={label}
        variant="outlined"
        deleteIcon={<Close className={classes.chipClose} fontSize="small" />}
        onDelete={() => {
          const value = [...val.filter((entry: any) => entry !== option)];
          setVal(value);
          props.onChange(value);
        }}
      />
    );
  });

  const renderInput = (params: any): ReactNode => {
    if (Search) {
      params.InputProps.startAdornment = (
        <>
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
          {params.InputProps.startAdornment}
        </>
      );
    }

    return (
      <TextField {...params} variant="standard" placeholder={props.placeholder} id={props.placeholder} fullWidth />
    );
  };

  const onChange = (value: any, e: any) => {
    const isValid = value?.every((item: any) => typeof item === 'object');
    if (props.name === 'operations' && typeof e.target.value !== 'number' && !isValid) return;
    setVal(value);
    props.onChange(value);
  };

  return (
    <div style={{ width: '100%' }}>
      <Autocomplete
        id={`autoComplete=${props.placeholder}`}
        data-id={`autoComplete=${props.placeholder}`}
        multiple
        freeSolo
        filterSelectedOptions
        options={props.values}
        onChange={(e, newValue: any) => onChange(newValue, e)}
        getOptionLabel={(option: any) => option.title}
        // @ts-ignore
        renderTags={() => {}}
        value={val}
        renderInput={renderInput}
      />
      <div>{valHtml}</div>
    </div>
  );
};
